[
    "abalone",
    "acetate",
    "acetylated hydrogenated lard glyceride",
    "acetylated lanolin",
    "acetylated lanolin alcohol",
    "acetylated lanolin ricinoleate",
    "acetylated tallow",
    "acidophilus milk",
    "adrenaline",
    "adrenals of cattle",
    "adrenals of hogs",
    "adrenals of sheep",
    "afterbirth",
    "alanine",
    "alcloxa",
    "aliphatic alcohol",
    "alligator",
    "alligator skin",
    "alpha-hydroxy acids",
    "ambergris",
    "amerachol",
    "amerchol l101",
    "aminiuccinate acid",
    "ammonium caseinate",
    "amniotic fluid",
    "ampd isoteric hydrolyzed animal protein",
    "amylase",
    "anchovies",
    "anchovy",
    "angora",
    "animal bones",
    "animal collagen amino acids",
    "animal fat",
    "animal fats",
    "animal fats and oils",
    "animal hair",
    "animal keratin amino acids",
    "animal oil",
    "animal oils",
    "animal placenta",
    "animal protein derivative",
    "animal tissue extract",
    "arachidonic acid",
    "arachidyl proprionate",
    "astrakhan",
    "back bacon",
    "back fat",
    "bacon",
    "bass",
    "batyl alcohol",
    "batyl isostearate",
    "bear",
    "bee pollen",
    "bee products",
    "beef",
    "beef heart",
    "beef liver",
    "beef tongue",
    "beepollen",
    "beeswax",
    "beeswax honeycomb",
    "belly bacon",
    "benzyltrimonium hydrolyzed animal protein",
    "bison",
    "blood",
    "blood plasma fractionation",
    "blood tongue",
    "boar bristles",
    "boiled ham",
    "bone ash",
    "bone char",
    "bone char(coal)/boneblack",
    "bone charcoal",
    "bone earth",
    "bone meal",
    "bone phosphate",
    "bone soup",
    "bone/bonemeal",
    "boneblack",
    "bonemeal",
    "bonito",
    "bovine serum albumin",
    "brain extract",
    "bratwurst",
    "brawn",
    "breakfast bacon",
    "bresaola",
    "bruehwurst",
    "bruhwurst",
    "buffalo",
    "buffalo milk",
    "bushmeat",
    "butter",
    "butter fat",
    "butter solids",
    "buttermilk",
    "buttermilk powder",
    "c30-46 piscine oil",
    "calamari",
    "calciferol",
    "calciferool",
    "calcium caseinate",
    "calf liver",
    "calfskin",
    "calfskin extract",
    "camel milk",
    "canadian bacon",
    "cantharadin",
    "cantharides tincture",
    "capiz",
    "caprylic triglyceride",
    "carbamide",
    "caribou",
    "carmine",
    "carmine cochineal carminic acid",
    "carmine/carminic acid",
    "carminic",
    "carminic acid",
    "carotene",
    "carotene provitamin a beta carotene",
    "carp",
    "casein",
    "casein caseinate",
    "caseinate",
    "caseinogen",
    "cashmere",
    "castor",
    "castor castoreum",
    "castoreum",
    "catfish",
    "catgut",
    "catharidin",
    "caviar",
    "caviar(e)",
    "caviare",
    "cera flava",
    "cerebrosides",
    "ceteth",
    "ceteth-02",
    "ceteth-1",
    "ceteth-10",
    "ceteth-2",
    "ceteth-30",
    "ceteth-4",
    "ceteth-6",
    "cetyl lactate",
    "cetyl myristate",
    "chamois",
    "cheese",
    "chicken",
    "chicken breast",
    "chicken liver",
    "chicken loaf",
    "chipped ham",
    "chitosan",
    "cholesterin",
    "cholesterol",
    "choline bitartrate",
    "chondroitin",
    "chopped ham",
    "chorizo",
    "chymotrypsin",
    "clarified butter",
    "clotted cream",
    "cochineal",
    "cod",
    "cod liver oil",
    "cold cuts",
    "coleth-24",
    "collagen",
    "collagen hydrolysate",
    "condensed milk",
    "confectioners glaze",
    "cooked ham",
    "cooked meats",
    "coral",
    "corned beef",
    "cornish game hen",
    "cortico steroid",
    "corticosteroid",
    "cortisone corticosteroid",
    "cotechino",
    "cottage cheese",
    "crab",
    "crabmeat",
    "crawfish",
    "crayfish",
    "cream",
    "crustacean shellfish",
    "curds",
    "custard",
    "cysteine, l-form",
    "cystine",
    "dark meat",
    "dashi",
    "dea-oleth-10 phosphate",
    "deer",
    "deer meat",
    "delactosed whey",
    "deli meats",
    "demineralized whey",
    "deoxyribonucleic acid",
    "desamido animal collagen",
    "desamido collagen",
    "desamidocollagen",
    "devon",
    "dicapryloyl cystine",
    "diethylene tricaseinamide",
    "dihydrocholesterol",
    "dihydrocholesterol octyledecanoate",
    "dihydrocholeth-15",
    "dihydrocholeth-30",
    "dihydrogenated tallow benzylmoniumchloride",
    "dihydrogenated tallow methylamine",
    "dihydrogenated tallow phthalate",
    "dihydroxyethyl tallow amine oxide",
    "dimethyl hydrogenated tallowamine",
    "dimethyl stearamine",
    "dimethyl tallowamine",
    "disodium hydrogenatedtallowglutamate",
    "disodium hydrogenated tallow glutamate",
    "disodium tallamido mea-sulfosuccinate",
    "disodium tallowaminodipropionate",
    "ditallowdimonium chloride",
    "dna",
    "down",
    "dried buttermilk",
    "dried egg yolk",
    "dry milk solids",
    "dry whole milk",
    "duck",
    "duck bacon",
    "duck liver",
    "duodenum substances",
    "dutch loaf",
    "dyes",
    "e120",
    "e441",
    "e542",
    "e904",
    "e913",
    "edible bone phosphate",
    "egg",
    "egg albumen",
    "egg albumen/albumin",
    "egg albumin",
    "egg oil",
    "egg powder",
    "egg protein",
    "egg whites",
    "egg yolk",
    "egg yolk extract",
    "egg yolks",
    "eggs",
    "eiderdown",
    "elastin",
    "elk bacon",
    "embryo extract",
    "emu",
    "emu oil",
    "epiderm oil r",
    "ergisterol",
    "ergosterol",
    "estradiol benzoate",
    "estrogen",
    "estrogen estradiol",
    "estrogen/estradiol",
    "estrone",
    "ethyl arachidonate",
    "ethyl ester of hydrolyzed animal protein",
    "ethyl lipineate",
    "ethyl morrhuate lipineate",
    "ethyl morrhuatelipineate",
    "ethylarachidonate",
    "ethylene dehydrogenated tallowamide",
    "evaporated milk",
    "ewe milk",
    "fat-free milk",
    "fat-free yogurt",
    "fatty acids",
    "feathers",
    "fermented camel milk",
    "fermented cream",
    "fermented milk",
    "fish",
    "fish glycerides",
    "fish liver",
    "fish liver oil",
    "fish livers",
    "fish oil",
    "fish sauce",
    "fish scales",
    "fishsauce",
    "fletan oil",
    "fur",
    "gel",
    "gelatin",
    "gelatin gel",
    "gelatin(e)",
    "gelatine",
    "gelbwurst",
    "ghee",
    "gizzards",
    "glucose tyrosinase",
    "glucuronic acid",
    "glycerides",
    "glycerin glycerol",
    "glycerin",
    "glyceryl lanolate",
    "glyceryls",
    "glycol",
    "glycreth-26",
    "goat",
    "goat cheese",
    "goat milk",
    "goose",
    "goose insulating feathers",
    "goose liver",
    "ground beef",
    "grouse",
    "guanine",
    "guanine pearl essence",
    "guanine/pearl essence",
    "guinea hen",
    "gypsy bacon",
    "haddock",
    "hair from hogs",
    "halibut",
    "ham",
    "ham and cheese loaf",
    "head cheese",
    "heavy cream",
    "heptylundecanol",
    "hide",
    "hide glue",
    "homogenized milk",
    "honey",
    "honeycomb",
    "horse",
    "horse hair",
    "horseflesh",
    "horsehair",
    "hog hair",
    "hot dog",
    "human placental protein",
    "human umbilical extract",
    "hyaluronic acid",
    "hydrlyzed human placental protein",
    "hydrogenated animal glyceride",
    "hydrogenated ditallow amine",
    "hydrogenated ditallowamine",
    "hydrogenated honey",
    "hydrogenated laneth-20",
    "hydrogenated laneth-25",
    "hydrogenated laneth-5",
    "hydrogenated lanolin",
    "hydrogenated lanolin alcohol",
    "hydrogenated lard glyceride",
    "hydrogenated shark-liver oil",
    "hydrogenated tallow acid",
    "hydrogenated tallow betaine",
    "hydrogenated tallow glyceride",
    "hydrolyzed animal elastin",
    "hydrolyzed animal keratin",
    "hydrolyzed animal protein",
    "hydrolyzed casein",
    "hydrolyzed elastin",
    "hydrolyzed human placental protein",
    "hydrolyzed keratin",
    "hydrolyzed milk protein",
    "hydrolyzed silk",
    "hydroxylated lanolin",
    "ice cream",
    "imidazolidinyl urea",
    "iron caseinate",
    "isinglass",
    "isobutylated lanolin",
    "isopropyl lanolate",
    "isopropyl tallowatelsopropyl lanolate",
    "isopropyl palmitate",
    "isopropylpalmitate",
    "isostearic hydrolyzed animal protein",
    "isostearoyl hydrolyzed animal protein",
    "jagdwurst",
    "jowl",
    "kangaroo",
    "katsuobushi",
    "katsuobushi (okaka)",
    "keratin",
    "keratinamino acids",
    "l-cysteine",
    "l-cysteine hydrochloride",
    "l-form",
    "lacotse-reduced milk",
    "lactalbumin",
    "lactic acid from whey",
    "lactic yeasts",
    "lacticacid",
    "lactoferrin",
    "lactoglobulin",
    "lactose",
    "lactose-free milk",
    "lactulose",
    "lamb",
    "lamb bacon",
    "laneth",
    "laneth-10",
    "laneth-11",
    "laneth-12",
    "laneth-13",
    "laneth-14",
    "laneth-15",
    "laneth-16",
    "laneth-17",
    "laneth-18",
    "laneth-19",
    "laneth-20",
    "laneth-21",
    "laneth-22",
    "laneth-23",
    "laneth-24",
    "laneth-25",
    "laneth-26",
    "laneth-27",
    "laneth-28",
    "laneth-29",
    "laneth-30",
    "laneth-31",
    "laneth-32",
    "laneth-33",
    "laneth-34",
    "laneth-35",
    "laneth-36",
    "laneth-37",
    "laneth-38",
    "laneth-39",
    "laneth-40",
    "laneth-5",
    "laneth-6",
    "laneth-7",
    "laneth-8",
    "laneth-9",
    "laneth-9 acetate",
    "laneth10 acetate",
    "lanogene",
    "lanoinamidedea",
    "lanolin",
    "lanolin acid",
    "lanolin acids",
    "lanolin alcohol",
    "lanolin alcohols",
    "lanolin linoleate",
    "lanolin oil",
    "lanolin ricinoleate",
    "lanolin wax",
    "lanolin(e)",
    "lanoline",
    "lanolin: lanolin acid",
    "lanoinamide dea",
    "lanosterol",
    "lanosterols",
    "lard",
    "lard glyceride",
    "lauroyl hydrolyzed animal protein",
    "leather",
    "lecithin choline bitartrate",
    "lecithin cholinebitartrate",
    "lipase",
    "liver",
    "liver extract",
    "liverwurst",
    "lobster",
    "low fat milk",
    "low fat yogurt",
    "luna sponge",
    "lunasponge",
    "luncehon loaf",
    "lunch meats",
    "luncheon meats",
    "mackerel",
    "magnesium caseinate",
    "magnesium lanolate",
    "magnesium tallowate",
    "malted milk",
    "mammarian extract",
    "marine oil",
    "marrow soup",
    "mayonnaise",
    "mea-hydrolyzed animal protein",
    "meat",
    "meat loaf",
    "meatball",
    "mechanically separated chicken",
    "menhaden oil",
    "methionine",
    "mettwurst",
    "milk",
    "milk chocolate",
    "milk derivative",
    "milk of mammals",
    "milk powder",
    "milk protein",
    "milk skin",
    "milk sugar",
    "milkfat",
    "milkpowder",
    "minced beef",
    "minced meat",
    "mink oil",
    "minkamidopropyl diethylamine",
    "mohair",
    "molluscan shellfish",
    "monkfish",
    "moose",
    "mortadella",
    "mossbunker oil",
    "mucopolysaccharides",
    "mullet",
    "muscle extract",
    "musk ambrette",
    "mussel",
    "mussels",
    "mutton",
    "myristate acid",
    "myristoyl hydrolyzed animal protein",
    "myristyl",
    "myristyls",
    "natural butter flavor",
    "natural red 4",
    "neck",
    "nonfat milk",
    "nougat",
    "ocenol",
    "octopus",
    "okaka",
    "oleamidopropyl dimethylamine hydrolyzed animal protein",
    "oleostearin",
    "oleostearine",
    "oleoyl hydrolyzed animal protein",
    "oleths",
    "oleyl arachidate",
    "oleyl betatine",
    "oleyl imidazoline",
    "oleyl lanolate",
    "oleyl oleate",
    "oleyl stearate",
    "oleylalcohol ocenol",
    "oleylimidazoline",
    "omega-3 fatty acids",
    "opossum",
    "organ meat",
    "organ meats",
    "organs",
    "ostrich",
    "ovalbumin",
    "ovarian extract",
    "ox bile",
    "ox gall",
    "oxgall",
    "oyster",
    "oysters",
    "palmitoyl hydrolyzed milk protein",
    "palmitoyl hydrolyzed animal protein",
    "pancetta",
    "paracasein",
    "partridge",
    "pasteurized milk",
    "pearl",
    "pearl essence",
    "peg-13 hydrogenated tallow amide",
    "peg-15 tallow polyamine",
    "peg-2 milk solids",
    "peg-20 tallowate",
    "peg-28 glyceryl tallowate",
    "peg-75 lanolin oil and wax",
    "peg-8 hydrogenated fish glycerides",
    "pentahydrosqualene",
    "pepsin",
    "perhydrosqualene",
    "pharmaceutical glaze",
    "pheasant",
    "picnic shoulder",
    "pigskin extract",
    "placenta",
    "placenta polypeptides protein",
    "placental enzymes",
    "placental extract",
    "placental protein",
    "plaice",
    "pogy oil",
    "pollock",
    "poltethylene",
    "poltethylene cetyl ether",
    "polyglycerol",
    "polyglyceryl-2 lanolin alcohol ether",
    "polypeptides protein",
    "porcine pancreas",
    "pork",
    "pork fat",
    "pork roll",
    "potassium caseinate",
    "potassium tallowate",
    "potassium undecylenoyl hydrolyzed animal protein",
    "poultry",
    "ppg-12-peg-50 lanolin",
    "ppg-2 methyl ether",
    "ppg-5-ceteth-20",
    "ppg-10",
    "ppg-20 methyl glucose ether",
    "ppg-30 cetyl ether",
    "ppg-30 lanolin ether",
    "prawn",
    "pregnenolone acetate",
    "pristane",
    "propolis",
    "prosciutto",
    "provitamin a",
    "purcelline oil syn",
    "quail",
    "quaternium 27",
    "rabbit",
    "red meat",
    "reduced fat milk",
    "reduced fat yogurt",
    "rennet casein",
    "resinous glaze",
    "reticulin",
    "retinol",
    "roast beef",
    "roast pork",
    "roe",
    "royal jelly",
    "sable",
    "sable brushes",
    "saccharide isomerate",
    "salami",
    "salceson",
    "salmon",
    "sardine",
    "sausage",
    "sausages",
    "scallop",
    "scallops",
    "sea sponge",
    "sea turtle oil",
    "seasponge",
    "serum albumin",
    "serum proteins",
    "shark liver oil",
    "shark-liver oil",
    "sheep milk",
    "sheep skin",
    "sheepskin",
    "shellac",
    "shellac resinous glaze",
    "shellac wax",
    "shoulder",
    "shrimp",
    "shrimph",
    "side bacon",
    "silk",
    "silk amino acids",
    "silk powder",
    "silk silk powder",
    "skim milk",
    "skin",
    "slab bacon",
    "sliced meats",
    "smoked ham",
    "snail",
    "snails",
    "snake",
    "snapper",
    "sodium / tea-lauroyl hydrolyzed animal protein",
    "sodium / tea-undecylenoyl hydrolyzed animal protein",
    "sodium caseinate",
    "sodium coco-hydrolyzed animal protein",
    "sodium soya hydrolyzed animal protein",
    "sodium tallow sulfate",
    "sodium tallowate",
    "sodium undecylenate",
    "sodium steroyl lactylate",
    "sodiumsteroyl lactylate",
    "soluble  collagen",
    "sour cream",
    "sour milk",
    "sour milk solids",
    "soured milk",
    "soya hydroxyethyl imidazoline",
    "sperm oil",
    "sperm whale intestines",
    "spermaceti",
    "spermaceticetyl palmitate sperm oil",
    "spleen extract",
    "sponge (luna and sea)",
    "squab",
    "squid",
    "squirrel",
    "steak",
    "stearyldimethyl amine",
    "steroids sterols",
    "sterols",
    "stewing steak",
    "stilton",
    "streaky bacon",
    "sweet dairy whey",
    "sweet whey",
    "sweetbreads",
    "sweetened condensed milk",
    "swordfish",
    "tallow",
    "tallow acid",
    "tallow amide",
    "tallow amine",
    "tallow amine oxide",
    "tallow aminopropylamine",
    "tallow fatty alcohol",
    "tallow glycerides",
    "tallow hydroxyethal imidazoline",
    "tallow imidazoline",
    "tallow trimonium chloride - tallow",
    "tallowamidopropylamine oxide",
    "talloweth-6",
    "tallowmide dea",
    "tallowmide dea and mea",
    "tallowmide mea",
    "tallowmidopropyl hydroxysultaine",
    "tallowminopropylamine",
    "tallowmphoacete",
    "tea-abietoyl hydrolyzedanimal protein",
    "tea-coco hydrolyzed animal protein",
    "tea-lauroyl animal collagen amino acids",
    "tea-lauroyl animal keratin amino acids",
    "tea-myristol hydrolyzed animal protein",
    "tea-undecylenoyl hydrolyzed animal protein",
    "testicular extract",
    "thuringian sausage",
    "tilapia",
    "tongue",
    "triethonium hydrolyzed animal protein ethosulfate",
    "trilaneth-4phosphate",
    "tripe",
    "triterpene alcohols",
    "trout",
    "trypsin",
    "tuna",
    "turkey",
    "turkey bacon",
    "turkey breast",
    "turtle",
    "turtle oil",
    "sea turtle oil",
    "tyrosine",
    "un-homogenized milk",
    "urea",
    "urea carbamide",
    "uric acid",
    "uric acid from cows",
    "uricacid",
    "urine",
    "veal",
    "veal loaf",
    "venison",
    "vitamin d ergocalciferol vitamin d",
    "vitamin h",
    "vitaminb",
    "vitaminb factor",
    "volaise",
    "whey",
    "whey powder",
    "whey protein",
    "whipped cream",
    "whipped topping",
    "white meat",
    "whole milk",
    "whole milk yogurt",
    "wild boar",
    "wild meat",
    "wool",
    "wool fat",
    "wool wax",
    "wool wax alcohols",
    "yoghurt",
    "yogurt",
    "zinc caseinate",
    "zinc hydrolyzed animal protein"
]
